import React from "react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_5d6559ee-fbdf-4544-b130-9532fa269e54/artifacts/ydisfzb6_IMG_5701.jpeg";

/**
 * Brand logo. Reconstructed from the provided asset but rendered as a
 * crisp custom mark (tile + wordmark) so it scales and aligns exactly
 * with our typographic system. The tile color matches the logo; the
 * wordmark mirrors the heavy/light contrast.
 */
const Logo = ({ size = "md", onClick }) => {
  const dims = {
    sm: { tile: 26, font: 16 },
    md: { tile: 32, font: 20 },
    lg: { tile: 56, font: 36 },
  }[size] || { tile: 32, font: 20 };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="brand-logo"
      aria-label="MahjongTrainer"
      className="flex items-center gap-3 group outline-none"
    >
      <span
        className="relative inline-flex items-center justify-center bg-[#F5F0E8] border-2 border-[#3D7A5A]"
        style={{
          width: dims.tile,
          height: dims.tile * 1.38,
          borderRadius: 6,
          boxShadow: "2px 2px 0 #2E5C44",
        }}
      >
        <span
          className="font-han leading-none"
          style={{
            color: "#C0392B",
            fontSize: dims.tile * 0.78,
            fontWeight: 900,
            letterSpacing: "-0.02em",
          }}
        >
          中
        </span>
      </span>
      <span
        className="leading-none tracking-tight"
        style={{ fontSize: dims.font, color: "#1A1A1A" }}
      >
        <span style={{ fontWeight: 900, letterSpacing: "-0.02em" }}>Mahjong</span>
        <span style={{ fontWeight: 300 }}>Trainer</span>
      </span>
    </button>
  );
};

export default Logo;
export { LOGO as LOGO_URL };
